export {
  lineHeight,
  letterSpacing,
  fontWeight,
  borderRadius
} from "./styledSystem";
